import { createTheme } from '@mui/material';

import { theme as coreTheme } from '@lendica/theme';

export const theme = createTheme(coreTheme);
